import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Skin } from '@core/interfaces/skin.interface';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { SkinsRowComponent } from '@core/components/skins-row/skins-row.component';
import { GAMES_CONFIG } from '@core/constants/games.constants';
import { WinToastGame } from '@core/constants/win-toast.constants';

@Component({
  selector: 'app-win-toast',
  standalone: true,
  imports: [DecimalPipe, BalanceIconComponent, SvgIconComponent, SkinsRowComponent],
  templateUrl: './win-toast.component.html',
  styleUrl: './win-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WinToastComponent {
  readonly game = input.required<WinToastGame>();
  readonly skins = input.required<Skin[]>();
  readonly totalValue = input.required<number>();
  readonly offerUrl = input.required<string>();

  readonly close = output<void>();

  protected readonly gameConfig = computed(() =>
    GAMES_CONFIG.find((g) => g.link === this.game()),
  );

  onClose(): void {
    this.close.emit();
  }

  /** The link opens the Steam offer in a new tab; the toast is done once clicked. */
  onAccept(): void {
    this.close.emit();
  }
}
